// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-select {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
}
.search-select > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
.search-select > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
.search-select > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
.search-select div.Controlled.Input {
  display: block;
  margin: 8px 0;
  position: relative;
  width: 100%;
  height: 32px;
  color: #002E33;
}
.search-select div.Controlled.Input > span.Label {
  position: absolute;
  width: 50%;
  text-overflow: ellipsis;
  height: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 32px;
  font-weight: 700;
  font-size: 12px;
  color: #002E33;
  overflow: hidden;
  white-space: nowrap;
}
.search-select div.Controlled.Input > span.Label + .Controlled {
  width: 50%;
  margin-left: 50%;
}
.search-select div.Controlled.Input > span.Label + .Controlled.CheckBoxInput {
  margin-left: 225px;
}
.search-select div.Controlled.Input input.Controlled {
  height: 100%;
  width: 100%;
  margin-left: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-family: "Aeonik", sans-serif;
  border: 1px solid #D3D6DF;
  padding: 4px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 16px;
  color: #002E33;
  padding-left: 12px;
}
.search-select div.Controlled.Input input.Controlled.selected {
  background-color: #F5F6F9;
}
.search-select__results {
  position: absolute;
  border: 1px solid #D3D6DF;
  border-radius: 2px;
  background-color: #FFF;
  width: 50%;
  margin-left: 50%;
  margin-top: -8px;
  z-index: 10;
  -webkit-box-shadow: 1px 1px 8px 0 #26282F;
          box-shadow: 1px 1px 8px 0 #26282F;
}
.search-select__results__list {
  max-height: 180px;
  overflow-y: auto;
}
.search-select__searching {
  display: inline-block;
  width: 20px;
  margin-left: -40px;
  vertical-align: top;
}
.search-select__searching .react-spinner {
  width: 20px;
}
.search-select__datasource {
  padding: 8px 20px;
  font-weight: 500;
  color: #697588;
  background-color: #E8E9F0;
  font-size: 12px;
}
.search-select__datasource img {
  float: right;
}
.search-select__results__result, .search-select__results__no-results, .search-select__results__searching {
  padding: 8px 20px;
  font-weight: 500;
  font-size: 12px;
  color: #697588;
}
.search-select__results__result.selected {
  background-color: #F5F6F9;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/SearchSelect/SearchSelect.scss","webpack://./src/client/Global/InputBase.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGA;ECiBE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cCvBa;AFKf;ACoBE;EArBA,kBAAA;EACA,UALW;EAMX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cCZa;EDab,gBAAA;EACA,mBAAA;ADIF;ACWE;EACE,UA9BS;EA+BT,gBA/BS;ADsBb;ACYE;EACE,kBAAA;ADVJ;AArBE;ECcA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAvBY;EAwBZ,cCvBa;AFiCf;ACRE;EArBA,kBAAA;EACA,UALW;EAMX,uBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAVY;EAWZ,gBAAA;EACA,eAAA;EACA,cCZa;EDab,gBAAA;EACA,mBAAA;ADgCF;ACjBE;EACE,UA9BS;EA+BT,gBA/BS;ADkDb;AChBE;EACE,kBAAA;ADkBJ;AA9CI;ECiCF,YAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cClDa;EFST,kBAAA;AA0DN;AAxDM;EACE,yBE4CC;AFcT;AArDE;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBEfI;EFgBJ,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,yCAAA;UAAA,iCAAA;AAuDJ;AArDI;EACE,iBAAA;EACA,gBAAA;AAuDN;AAnDE;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAqDJ;AApDI;EACE,WAAA;AAsDN;AAlDE;EACE,iBAAA;EACA,gBAAA;EACA,cEIK;EFHL,yBEOK;EFNL,eAAA;AAoDJ;AAlDI;EACE,YAAA;AAoDN;AA/CI;EAGE,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,cEZG;AF2DT;AA7CI;EACE,yBEVG;EFWH,eAAA;AA+CN","sourcesContent":["@import \"../../../Global/Colors.scss\";\n@import \"../../../Global/InputBase\";\n\n.search-select {\n  @include inputContainerRules;\n\n  div.Controlled.Input {\n    @include inputContainerRules;\n\n    input.Controlled {\n      @include inputInputRules;\n      padding-left: 12px;\n\n      &.selected {\n        background-color: $Gray20;\n      }\n    }\n  }\n\n  &__results {\n    position: absolute;\n    border: 1px solid $Gray50;\n    border-radius: 2px;\n    background-color: $White;\n    width: 50%;\n    margin-left: 50%;\n    margin-top: -8px;\n    z-index: 10;\n    box-shadow: 1px 1px 8px 0 $Gray200;\n\n    &__list {\n      max-height: 180px;\n      overflow-y: auto;\n    }\n  }\n\n  &__searching {\n    display: inline-block;\n    width: 20px;\n    margin-left: -40px;\n    vertical-align: top;\n    .react-spinner {\n      width: 20px;\n    }\n  }\n\n  &__datasource {\n    padding: 8px 20px;\n    font-weight: 500;\n    color: $Gray90;\n    background-color: $Gray30;\n    font-size: 12px;\n\n    img {\n      float: right;\n    }\n  }\n\n  &__results {\n    &__result,\n    &__no-results,\n    &__searching {\n      padding: 8px 20px;\n      font-weight: 500;\n      font-size: 12px;\n      color: $Gray90;\n    }\n    &__result.selected {\n      background-color: $Gray20;\n      cursor: pointer;\n    }\n  }\n}\n","@import '../Global/Colors';\n$inputHeight: 32px;\n$inputWidth: 50%;\n\n\n@mixin inputLabelRules {\n  position: absolute;\n  width: $inputWidth;\n  text-overflow: ellipsis;\n  height: 100%;\n  box-sizing: border-box;\n  line-height: $inputHeight;\n  font-weight: 700;\n  font-size: 12px;\n  color: $DeepSeaGreen;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n@mixin inputContainerRules {\n  display: block;\n  margin: 8px 0;\n  position: relative;\n  width: 100%;\n  height: $inputHeight;\n  color: $DeepSeaGreen;\n\n  > span.Label {\n    @include inputLabelRules;\n  }\n\n  > span.Label + .Controlled {\n    width: $inputWidth;\n    margin-left: $inputWidth;\n  }\n\n  > span.Label + .Controlled.CheckBoxInput {\n    margin-left: 225px;\n  }\n}\n\n@mixin inputInputRules {\n  height: 100%;\n  width: 100%;\n  margin-left: 0;\n  box-sizing: border-box;\n  font-family: \"Aeonik\", sans-serif;\n  border: 1px solid $Gray50;\n  padding: 4px;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 16px;\n  color: $DeepSeaGreen;\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
